<template>
  <ul>
    <router-link :to="{name: 'visitor'}">
      <li class="menu-item"><i class="fas fa-seedling icon"></i> <span class="opacity-100">{{ $t('pages.visitor.culture') }}</span></li>
    </router-link>
    <router-link :to="{name: 'VisitorNode'}">
      <li class="menu-item"><i class="fas fa-apple-alt icon"></i> <span class="opacity-100">{{ $t('pages.visitor.sensor') }}</span></li>
    </router-link>
    <router-link :to="{name: 'VisitorWeather'}">
      <li class="menu-item"><i class="fas fa-cloud icon"></i> <span class="opacity-100">{{ $t('pages.visitor.weatherStation') }}</span></li>
    </router-link>
  </ul>
</template>
  <script>
  
  export default {
    name: "visitor-menu",
    mounted() {
    },
    methods: {
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  